<template>
	<v-main style="padding: 0px 0px 0px;">
		<v-container style="background: linear-gradient(45deg,#ffffff,#257047);" fluid>
			<v-container>
				<v-row>
					<v-col cols="12" sm="6" md="6">
						<div class="mt-8 text-h5">Сервіси для бізнесу</div>
						<p class="mt-8 mb-16 text-body-1 font-weight-light">
							Широкий спектр сервісів в різних напрямках для сучасного бізнесу.<br>
							Доступно та зручно.
						</p>
						<!-- <v-btn outlined color="primary" :to="{name: 'connection'}">{{ $vuetify.lang.t('$vuetify.orderconnection') | capitalize }}</v-btn> -->
					</v-col>
					<v-col cols="12" sm="6" md="6" class="text-right d-flex align-stert mb-6">
						<img :src="require('../assets/honeycomb.svg')">
						<v-row>
							<v-col cols="12">
								<img :src="require('../assets/logo_tinex.jpg')">
							</v-col>
							<v-col cols="12">
								<img :src="require('../assets/logo_pvbki_ukr.png')">
							</v-col>
						</v-row>
					</v-col>
				</v-row>
			</v-container>
		</v-container>

		<v-main style="padding: 30px 0px 0px;">
			<!-- <v-container>
				<v-row>
					<v-col v-for="(item, index) in services" :key="index" cols="12" md="6">
						<ShopCard
							:overline="item.overline"
							:title="item.title"
							:subtitle="item.subtitle"
							:icon="item.icon"
							:router="item.router"
							:color="item.color"
						></ShopCard>
					</v-col>
				</v-row>
			</v-container> -->
			<v-container>
				<v-expansion-panels flat v-model="panel" multiple>
					<v-expansion-panel v-for="(category, c) in categories" :key="c">
						<v-expansion-panel-header>
							<span class="text-h6">{{ category.name }}</span>
						</v-expansion-panel-header>
						<v-expansion-panel-content>
							<v-row>
								<v-col v-for="(item, index) in category.services" :key="index" cols="12" md="6">
									<ShopCard
										:overline="item.overline"
										:title="item.title"
										:subtitle="item.subtitle"
										:icon="item.icon"
										:router="item.router"
										:color="item.color"
									></ShopCard>
								</v-col>
							</v-row>
						</v-expansion-panel-content>
					</v-expansion-panel>
				</v-expansion-panels>

				<v-expansion-panels flat v-model="panel2" multiple v-if="isAdmin">
					<v-expansion-panel v-for="(category, c) in categories2" :key="c">
						<v-expansion-panel-header>
							<span class="text-h6">{{ category.name }}</span>
						</v-expansion-panel-header>
						<v-expansion-panel-content>
							<v-row>
								<v-col v-for="(item, index) in category.services" :key="index" cols="12" md="6">
									<ShopCard
										:overline="item.overline"
										:title="item.title"
										:subtitle="item.subtitle"
										:icon="item.icon"
										:router="item.router"
										:color="item.color"
									></ShopCard>
								</v-col>
							</v-row>
						</v-expansion-panel-content>
					</v-expansion-panel>
				</v-expansion-panels>

				<!-- <v-expansion-panels flat v-model="panel3" multiple>
					<v-expansion-panel v-for="(category, c) in categories3" :key="c">
						<v-expansion-panel-header>
							<span class="text-h6">{{ category.name }}</span>
						</v-expansion-panel-header>
						<v-expansion-panel-content>
							<v-row>
								<v-col v-for="(item, index) in category.services" :key="index" cols="12" md="6">
									<ShopCard
										:overline="item.overline"
										:title="item.title"
										:subtitle="item.subtitle"
										:icon="item.icon"
										:router="item.router"
										:color="item.color"
									></ShopCard>
								</v-col>
							</v-row>
						</v-expansion-panel-content>
					</v-expansion-panel>
				</v-expansion-panels> -->
			</v-container>
		</v-main>
		<v-overlay :value="loading">
			<v-progress-circular
				indeterminate
				size="64"
			></v-progress-circular>
		</v-overlay>
	</v-main>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
//import ShopCard from '@/views/shop.card'
import ShopCard from '@/views/shop.card2'

export default {
	name: 'Home',
	components: {
		ShopCard,
	},

	data () {
		return {
			loading: false,
			browser: null,
			
			panel: [0,1,2,3,4,5],
			panel2: [0,1,2,3,4,5],
			panel3: [0,1,2,3,4,5],

			categories2: [
				{
					name: 'В розробці',
					icon: '',
					services: [
						{ title: 'Прайс-листи', subtitle: 'Перелік товарів або послуг із зазначенням їхньої вартості', overline: null, icon: 'mdi-script-text', color: 'green-darken-1', router: 'Pricelist'},
						{ title: 'Показники діяльності страховиків', subtitle: 'Основні показники діяльності страховиків; Дані регуляторного балансу (IRB); Дані про показники діяльності зі страхування за контрагентами/ видами договорів (IRPL); Дані про показники діяльності зі страхування за каналами збуту; Дані про кількість договорів страховика, застрахованих фізичних осіб та страхових подій (випадків) (IR20); ', overline: null, icon: 'mdi-script-text', color: 'green-darken-1', router: 'InsuranceIndicator'},
						{ title: 'КАСКО калькулятор', subtitle: 'Розрахунок вартісті добровільного страхування автомобіля', overline: null, icon: 'mdi-calculator', color: 'green-darken-1', router: 'InsuranceCalculatorKasko'},
						{ title: 'Парки', subtitle: 'Парки транспортних засобів', overline: null, icon: 'mdi-car-2-plus', color: 'green-darken-1', router: 'Fleet'},
					],
				},
			],

			categories3: [
				{
					name: 'Експеримент',
					icon: '',
					services: [
						{ title: 'VIN Decoder', subtitle: 'Vehicle Identification Number (VIN) is a unique code given to motor vehicles by their manufacturer for identification purposes', overline: null, icon: 'mdi-script-text', color: 'green-darken-1', router: 'VehicleVinDecoder'},
					],
				},
			],
			/* straights: [
				{
					title: 'Транспортні засоби',
					icon: '',
					services: [
						{ title: 'Оцінка ринкової вартості за параметрами', },
						{ title: 'Оцінка ринкової вартості за номером державної реєстрації та/або vin-кодом', },
						{ title: 'Оцінка за методикою товарознавчої експертизи', },
						{ title: 'Оцінка за методикою товарознавчої експертизи', },
					],
				},
				{
					title: 'Лікарські засоби',
					icon: '',
					services: [
						{ title: 'Оцінка динаміки змін вартості', },
						{ title: 'Оцінка ринкової вартості в поточний період', },
						{ title: 'Оцінка рецептів, рахунків, прайсів', },
					],
				},
				{
					title: 'Медичні послуги',
					icon: '',
					services: [
						{ title: 'Оцінка ринкової вартості', },
						{ title: 'Оцінка вартості лікування', },
					],
				},
				{
					title: 'Лабораторні дослідження',
					icon: '',
					services: [
						{ title: 'Оцінка ринкової вартості', },
					],
				},
			], */
		}
	},
	computed: {
		...mapGetters([ 'services', 'roles' ]),

		categories() {
			//console.log(this.$options.name, 'categories','services', this.services)

			let results = []
			this.services.forEach((service) => {
				let category = results.find(element => element.id === service.category.id);
				if(!category) {
					category = {
						id: service.category.id,
						nop: service.category.nop,
						name: service.category.name,
						code: service.category.code,
						color: service.category.color,
						icon: service.category.icon,
						services: []
					}

					results.push(category)
				}

				category.services.push(service)
			})

			return results.sort(function (a, b) {return parseInt(a.nop) - parseInt(b.nop)}); ;
		},

		isAdmin() {
			return this.roles.includes('ADMIN')
		},

		/* gradient() {

			var colors = [
				{ id: 0, hex: "#ffffff", disabled: false },
				{ id: 1, hex: "#257047", disabled: false }
			]

			let gradient = "linear-gradient(45deg";
			colors.forEach( function(e) {
				gradient += "," + e.hex;
			});
			gradient += ")";

			console.log('gradient', gradient)
			return gradient;
		} */

	},
	created () {

		// Дата компіляції
		//console.log('build', document.documentElement.dataset.buildTimestampUtc)
		
		// інформація про браузер, який використовується та операційну систему
		var platform = require('platform');
		//console.log('platform', platform)

		this.browser = {
			name: platform.name, // 'Safari'
			version: platform.version, // '5.1'
			product: platform.product, // 'iPad'
			manufacturer: platform.manufacturer, // 'Apple'
			layout: platform.layout, // 'WebKit'
			os: platform.os, // 'iOS 5.0'
			description: platform.description, // 'Safari 5.1 on Apple iPad (iOS 5.0)'
			ua: platform.ua
		}
		//console.log('browser', this.browser)
	},
}
</script>


<style>
/* @import url("https://fonts.googleapis.com/css?family=Questrial"); */

.v-application .text-h4 {
  	font-family: "Open Sans",Sans-Serif !important;
}

/* "Roboto", sans-serif !important; */
/* font-family:"Open Sans",Sans-Serif;font-size:16px */

</style>

